import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="min-h-screen w-full bg-[#FAF3E0] py-12 md:py-20 px-4" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="flex flex-col-reverse md:flex-row items-center gap-8 md:gap-16" data-id="element-16">
          {/* Left Content */}
          <motion.div className="flex-1 text-center md:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-17">
            <h1 className="md:text-5xl lg:text-6xl font-bold text-[#1B4332] mb-6 text-[32px]" data-id="element-18">
              Barriga plana en 21 días{' '}
              <span className="italic font-normal" data-id="element-19">(sin dejar el arroz)</span>
            </h1>

            <p className="md:text-xl text-[#1B4332]/80 mb-8 max-w-xl text-[16px]" data-id="element-20">
              El protocolo anti-hinchazón en 3 fases para mujeres en Colombia
              que quieren desinflamar, mejorar digestión y volver a sentir su
              ropa "soltarse"… sin dietas extremas.
            </p>

            <div className="bg-[#1B4332]/5 rounded-2xl p-6 mb-8 text-left" data-id="element-21">
              <p className="text-[#1B4332]/90 italic leading-relaxed" data-id="element-22">
                Te voy a describir un momento.
              </p>
              <p className="text-[#1B4332]/90 mt-4 leading-relaxed" data-id="element-23">
                Te despiertas y estás "normal". Te arreglas. Te pones el jean.
                Sales.
              </p>
              <p className="text-[#1B4332]/90 mt-4 leading-relaxed" data-id="element-24">
                Y en algún punto del día —después del almuerzo, después del
                café, después del afán—
                <strong data-id="element-25"> tu barriga cambia.</strong>
              </p>
              <p className="text-[#1B4332]/90 mt-4 leading-relaxed" data-id="element-26">
                No un poquito. Cambia en serio.
              </p>
              <p className="text-[#1B4332]/90 mt-4 leading-relaxed" data-id="element-27">
                Te aprieta la ropa. Te sientes pesada. Te da rabia porque no fue
                que comiste "tanto". Y lo peor: ya ni sabes qué quitar, porque
                pareciera que TODO te cae mal.
              </p>
              <p className="text-[#1B4332] mt-4 font-medium leading-relaxed" data-id="element-28">
                Ahí es donde este protocolo entra: no para ponerte a dieta… sino
                para devolverte control.
              </p>
            </div>

            <motion.a href="#precio" className="inline-block bg-[#C75B39] text-white text-lg font-semibold px-10 py-4 rounded-full 
                         hover:scale-105 transition-transform duration-200 shadow-lg hover:shadow-xl" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} data-id="element-29">
              Quiero desinflamar mi barriga →
            </motion.a>
          </motion.div>

          {/* Right Image */}
          <motion.div className="flex-1 w-full max-w-md md:max-w-none" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-30">
            <img src="https://cdn.magicpatterns.com/uploads/kdHh13AcDX93Z2kLKPUu91/5.png" alt="Barriga Plana en 21 Días - Protocolo anti-hinchazón colombiano" className="w-full h-auto rounded-3xl shadow-2xl" loading="lazy" decoding="async" width={600} height={600} data-id="element-31" />
          </motion.div>
        </div>
      </div>
    </section>;
}